"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDLNotFoundError = exports.ProgramHelpers = exports.Program = void 0;
const anchor_1 = require("@project-serum/anchor");
const loglevel_1 = __importDefault(require("loglevel"));
const connection_1 = require("../connection");
const send_1 = require("../transaction/send");
__exportStar(require("./objectWrapper"), exports);
var Program;
(function (Program_1) {
    class Program {
        constructor() {
            this.asyncSigning = false;
        }
        get id() {
            return this.PROGRAM_ID;
        }
        get client() {
            return this._client;
        }
        set client(client) {
            this._client = client;
        }
        sendWithRetry(instructions, signers = [], options = { commitment: "confirmed" }) {
            if (this.asyncSigning) {
                return (0, send_1.sendAsyncSignedTransactionWithRetry)(this.client.provider.connection, this.client.provider.wallet, instructions, signers, options.commitment, options.timeout);
            }
            return (0, send_1.sendTransactionWithRetry)(this.client.provider.connection, this.client.provider.wallet, instructions, signers, options.commitment, options.timeout);
        }
        sendWithAsyncSigningAndRetry(instructions, signers = [], options = { commitment: "confirmed" }) {
            return (0, send_1.sendAsyncSignedTransactionWithRetry)(this.client.provider.connection, this.client.provider.wallet, instructions, signers, options.commitment, options.timeout);
        }
        static getProgramWithConfig(type, config) {
            return ProgramHelpers.getProgramWithConfig(type, config);
        }
        static getProgramWithWallet(type, wallet, env, customRpcUrl) {
            return ProgramHelpers.getProgram(type, wallet, env, customRpcUrl);
        }
        static getProgramWithWalletKeyPair(type, walletKeyPair, env, customRpcUrl) {
            return ProgramHelpers.getProgram(type, null, env, customRpcUrl, walletKeyPair);
        }
        static getProgram(type, anchorWallet, env, customRpcUrl, walletKeyPair) {
            return ProgramHelpers.getProgram(type, anchorWallet, env, customRpcUrl, walletKeyPair);
        }
    }
    Program.PREFIX = "";
    Program_1.Program = Program;
})(Program = exports.Program || (exports.Program = {}));
var ProgramHelpers;
(function (ProgramHelpers) {
    async function getProgramWithConfig(type, config) {
        let { client, provider, idl } = config;
        const instance = new type();
        instance.asyncSigning = config.asyncSigning;
        if (client) {
            instance.client = client;
            return instance;
        }
        if (provider && !idl) {
            idl = await anchor_1.Program.fetchIdl(instance.id, provider);
        }
        if (!idl) {
            throw new IDLNotFoundError(instance.id.toString());
        }
        if (provider) {
            const client = new anchor_1.Program(idl, instance.id, provider);
            instance.client = client;
            return instance;
        }
        return Promise.resolve(instance);
    }
    ProgramHelpers.getProgramWithConfig = getProgramWithConfig;
    function getProgram(type, wallet, env, customRpcUrl, walletKeyPair) {
        if (customRpcUrl)
            loglevel_1.default.debug("USING CUSTOM RPC URL:", customRpcUrl);
        const solConnection = new anchor_1.web3.Connection(customRpcUrl || (0, connection_1.getCluster)(env));
        let providerWallet;
        if (wallet) {
            providerWallet = wallet;
        }
        else if (walletKeyPair) {
            providerWallet = new anchor_1.Wallet(walletKeyPair);
        }
        else if (!walletKeyPair) {
            throw new Error("Wallet nor a keypair was passed into Program.getProgram");
        }
        const provider = new anchor_1.AnchorProvider(solConnection, providerWallet, {
            preflightCommitment: "recent",
        });
        const config = {
            asyncSigning: false,
            provider,
        };
        return this.getProgramWithConfig(type, config);
    }
    ProgramHelpers.getProgram = getProgram;
})(ProgramHelpers = exports.ProgramHelpers || (exports.ProgramHelpers = {}));
class IDLNotFoundError extends Error {
    constructor(message) {
        super(`IDL Not Found for id: ${message}`);
        // Set the prototype explicitly
        // Ref: https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, Error.prototype);
    }
}
exports.IDLNotFoundError = IDLNotFoundError;
//# sourceMappingURL=index.js.map